/**
 * Created by Nikita Besshaposhnikov on 15.03.16.
 */

var CORE_BUILD = false;


